import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'aura-user-subscription-portal-card',
  imports: [MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './subscription-portal-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSubscriptionPortalCardAuraComponent {
  loadingPortal = input<boolean>(false);
  manage = output<void>();
}
